module.exports = __webpack_public_path__ + "static/media/pointer_dark.cd493626.svg";